import React from 'react';

const Article = React.forwardRef(({ title, value, isObject, isSelected, onViewDetails }, ref) => {
    return (
        <article
            ref={ref}
            className={`rounded-lg border-2 p-6 min-w-[250px] flex-shrink-0 transition-all duration-200 ${
                isSelected
                    ? "border-blue-500 bg-blue-50 shadow-lg"
                    : "border-gray-200 bg-slate-100 hover:border-gray-300"
            }`}
        >
            <div>
                <p className="text-sm text-gray-500">{title}</p>
                {isObject ? (
                    <div className="text-lg font-medium text-gray-900">
                        <ObjectPreview data={value} />
                    </div>
                ) : (
                    <p className="text-2xl font-medium text-gray-900">{value}</p>
                )}
            </div>
            <button
                onClick={onViewDetails}
                className="mt-4 inline-block text-blue-600 hover:underline"
            >
                View Details →
            </button>
        </article>
    );
});

const ObjectPreview = ({ data }) => {
    if (!data) return <p>No data</p>;

    if (typeof data !== 'object' || data === null) {
        return <p>{String(data)}</p>;
    }

    const allKeys = Object.keys(data);
    const previewKeys = allKeys.slice(0, 2);
    const remainingFields = allKeys.length - previewKeys.length;
    
    return (
        <div className="space-y-1">
            {previewKeys.map(key => (
                <div key={key} className="flex items-center">
                    <span className="font-semibold text-sm">{key}:</span>
                    <span className="ml-2 text-sm truncate">
                        {typeof data[key] === 'object' && data[key] !== null
                            ? '{...}' 
                            : String(data[key])}
                    </span>
                </div>
            ))}
            {remainingFields > 0 && (
                <p className="text-xs text-gray-500">+{remainingFields} more fields</p>
            )}
        </div>
    );
};

export default Article;